import { render, staticRenderFns } from "./RoleSwitch.vue?vue&type=template&id=37266b6e&"
import script from "./RoleSwitch.vue?vue&type=script&lang=ts&"
export * from "./RoleSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports